export default __webpack_public_path__ + "static/media/goat_shoulder.f8c36f48.png";